import React, { Fragment } from 'react';
import {
  Edit,
  SimpleForm,
  Show,
  SimpleShowLayout,
  DateField,
  ImageField,
  Filter,
  SelectInput,
  TextInput,
  NullableBooleanInput,
  ReferenceInput,
  List,
  Datagrid,
  TextField,
  LongTextInput,
  EditButton,
  FunctionField,
  NumberField,
  CardActions,
  ListButton,
  ShowButton,
} from 'react-admin';

import { DateInput, DateTimeInput } from 'react-admin-date-inputs';

import BulkDeleteButton from './ui/BulkDeleteButton';
import UrlEncodedField from './ui/UrlEncodedField';
import MediaField from './ui/MediaField';

const ArticlesBulkActionButtons = props => (
  <Fragment>
      <BulkDeleteButton encoded={true} {...props} />
  </Fragment>
);

const sourceRowStyle = (record, index) => ({
  backgroundColor:
    record.deleted ? '#FDF3F4' : 'white',
  textDecoration:
    record.deleted ? 'line-through' : 'none',
});

export const ArticlesList = props => (
  <List title="Articles" {...props} bulkActionButtons={<ArticlesBulkActionButtons />} sort={{ field: 'publish_date', order: 'desc' }} filters={<ArticleFilter />}>
    <Datagrid rowStyle={sourceRowStyle}>
      <ImageField source="thumbnail" sortable={false} />
      <UrlEncodedField source="id" label="Url" display="title" sortable={false} />
      <FunctionField
        sortable={false}
        source="by_category"
        label="Stats"
        render={(record, source) => {
          const { likes = 0, shares = 0, comments = 0 } = record['activities'] || {};
          return (
            <ul>
              <li>likes: {likes}</li> <li>shares: {shares}</li> <li>comments: {comments}</li>
            </ul>
          );
        }}
      />
      <TextField label="Category" source="category.name" />
      <TextField source="site.name" label="Site" />
      <TextField source="author" />
      <DateField source="publish_date" showTime={true} />
      <NumberField label="M. Weight" source="manual_weight" />
      <EditButton label="" />
    </Datagrid>
  </List>
);

const ArticleFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <LongTextInput label="URL" source="x_id" alwaysOn />

    <ReferenceInput label="Category" source="category.ref" reference="articles/categories" perPage={100}>
      <SelectInput source="name" />
    </ReferenceInput>

    <ReferenceInput
      label="Site"
      source="site.id"
      reference="mediasources"
      perPage={400}
      filter={{ crawlable: true }}
      sort={{ field: 'id', order: 'ASC' }}
    >
      <SelectInput source="name" />
    </ReferenceInput>

    <NullableBooleanInput label="Deleted" source="deleted" />

    <NullableBooleanInput label="Promoted" source="promoted" />

    <SelectInput
      source="manual_weight"
      allowEmpty={true}
      choices={[
        { id: 1, name: '1' },
        { id: 2, name: '2' },
        { id: 3, name: '3' },
        { id: 4, name: '4' },
        { id: 5, name: '5' },
        { id: 6, name: '6' },
        { id: 7, name: '7' },
        { id: 8, name: '8' },
        { id: 9, name: '9' },
        { id: 10, name: '10' },
      ]}
    />

    <DateInput label="Published Before" source="range.publish_date.lte" options={{ format: 'dd.MM.yyyy', clearable: true }} />
    <DateInput label="Published After" source="range.publish_date.gte" options={{ format: 'dd.MM.yyyy', clearable: true }} />
  </Filter>
);

const Title = ({ record }) => {
  return <span>Article {record ? `"${record.title}"` : ''}</span>;
};



export const ArticleDetails = props => (
  <Show title={<Title />} {...props}>
    <SimpleShowLayout>
      <ImageField source="thumbnail" />
      <UrlEncodedField source="id" label="Url" display="title" />
      <TextField source="category.name" label="Category"  />
      <FunctionField
        source="source_category"
        label="Source categories"
        render={(record, source) => {
          return (
            <div>{record.source_category.map(c => <span key={c}>{c}, </span>)}</div>
          );
        }}
      />
      <TextField source="text" />
      <DateField source="publish_date" showTime />
      <DateField source="fetch_date" showTime />
      <MediaField />
    </SimpleShowLayout>
  </Show>
);

const ArticlesEditActions = ({ basePath, data, resource }) => (
  <CardActions>
      <ShowButton basePath={basePath} record={data} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
      <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
  </CardActions>
);

export const ArticleEdit = props => (
  <Edit title={<Title />} actions={<ArticlesEditActions />} {...props}>
    <SimpleForm>
      <SelectInput
        source="manual_weight"
        allowEmpty={true}
        choices={[
          { id: 1, name: '1' },
          { id: 2, name: '2' },
          { id: 3, name: '3' },
          { id: 4, name: '4' },
          { id: 5, name: '5' },
          { id: 6, name: '6' },
          { id: 7, name: '7' },
          { id: 8, name: '8' },
          { id: 9, name: '9' },
          { id: 10, name: '10' },
        ]}
      />
      <NullableBooleanInput label="Promoted" source="promoted" allowEmpty={true} />
      <DateTimeInput label="Promoted Until" source="promoted_date" options={{ format: 'HH:mm dd.MM.yyyy', ampm: false, clearable: true }} />
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/resources/articles.js